module.exports = __webpack_public_path__ + "media/images/legalsoftsolution-322abe906b16a42692b8d4d1d7768b7e.png";